import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { create } from "jss";
import rtl from "jss-rtl";
// import customTheme from "@core/style/theme";
import { StylesProvider, jssPreset } from "@material-ui/styles";
import MainApp from "@features/Layout/App/index";
import { IntlProvider } from "react-intl";
import CssBaseline from "@material-ui/core/CssBaseline/CssBaseline";
import ThemeContext from "@context/ThemeContext";
import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
import { paletteLight, paletteDark } from "@core/style/palette";
import userApi from "@api/user";
import { UpdateSettingProvider } from "@context/UpdateSettingProvider";
import overrides from "@core/style/overrides";
import pickerOverrideDark from "@core/style/pickerOverrideDark";
import pickerOverrideLight from "@core/style/pickerOverrideDark";
import { fontSize } from "@core/style/fontSize";

const jss = create({
  plugins: [...jssPreset().plugins, rtl()],
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: document.getElementById("jss-insertion-point") ?? undefined,
});

const App = () => {
  const [themeColor, setThemeColor] = useState(
    window.localStorage.getItem("theme") || "LIGHT"
  );
  const [setting, setSetting] = useState({});
  const [updateTheme, setUpdateTheme] = useState(false);
  const token = window.localStorage.getItem("access_token");
  useEffect(() => {
    if (!!token) {
      userApi
        .getCurrentUserSummary()
        .then((data) => {
          setThemeColor(data?.content?.setting?.theme);
          setSetting(data?.content?.setting);
        })
        .catch((e) => {});
    }
  }, [token]);

  const changeThemeApi = (theme) => {
    userApi
      .changeUserSettings({
        payload: {
          ...setting,
          theme: theme,
        },
      })
      .then((data) => {
        setUpdateTheme(!updateTheme);
      })
      .catch((data) => {});
  };

  const toggleTheme = () => {
    if (themeColor === "LIGHT") {
      setThemeColor("DARK");
      changeThemeApi("DARK");
      window.localStorage.setItem("theme", "DARK");
    } else {
      setThemeColor("LIGHT");
      changeThemeApi("LIGHT");
      window.localStorage.setItem("theme", "LIGHT");
    }
  };

  const theme = createMuiTheme({
    fontSize: fontSize,
    spacing: 2,
    direction: "rtl",
    distance: "30px",
    typography: {
      fontFamily: "iranyekan",
    },
    palette: themeColor === "LIGHT" ? { ...paletteLight } : { ...paletteDark },
    overrides:
      themeColor === "LIGHT"
        ? { ...overrides, pickerOverrideLight }
        : { ...overrides, pickerOverrideDark },
  });

  return (
    <div dir="rtl">
      <UpdateSettingProvider>
        <StylesProvider jss={jss}>
          <ThemeContext.Provider value={{ toggleTheme, themeColor }}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <IntlProvider locale="FA" defaultFormats={String}>
                <MainApp />
              </IntlProvider>
            </ThemeProvider>
          </ThemeContext.Provider>
        </StylesProvider>
      </UpdateSettingProvider>
    </div>
  );
};

export default App;
